import authReducer from '@redux/auth/authSlice';
import commonReducer from '@redux/common/commonSlice';
import loadingReducer from '@redux/loading/loadingSlice';
import merchantReducer from '@redux/merchant/merchantSlice';
import onboardingReducer from '@redux/onboarding/onboardingSlice';
import permissionReducer from '@redux/permission/permissionSlice';
import settingsReducer from '@redux/settings/settingsSlice';
import { combineReducers } from '@reduxjs/toolkit';

const rootReducer = combineReducers({
  auth: authReducer,
  permission: permissionReducer,
  loading: loadingReducer,
  settings: settingsReducer,
  common: commonReducer,
  merchant: merchantReducer,
  onboarding: onboardingReducer,
});

export default rootReducer;
